<script setup lang="ts">
import {PathwayStepConsent} from "@/program/interfaces/Program";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {documentApi, pathwayApi} from "@/container";
import * as Sentry from "@sentry/vue";
import {ref} from "vue";
import {Printer} from "@lucide/vue";

const props = defineProps<{
    consent: PathwayStepConsent;
    consumerKey: string;
}>();

const loading = ref<boolean>(false);

const downloadAndPrint = async () => {
    loading.value = true;

    return documentApi()
        .document(props.consent.document.id, props.consumerKey)
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response], {type: response.type}));
            const printWindow = window.open(url);

            if (printWindow) {
                printWindow.onload = () => {
                    try {
                        printWindow.print();
                    } catch (e) {
                        Sentry.captureException(e);
                    }
                };
            }
        })
        .then(() => {
            return pathwayApi().storeConsent(props.consent.id, props.consumerKey);
        })
        .finally(() => loading.value = false);
};
</script>

<template>
  <div class="px-4 bg-primary/20 flex py-4 justify-between items-center">
    <h2>{{ consent.description }}</h2>
    <BaseButton density="comfortable" :loading="loading" @click="downloadAndPrint()">
      <Printer class="w-4 mr-2" />{{ consent.action }}
    </BaseButton>
  </div>
</template>
